<div class="sw" [class.sw--cards]="variant === 'cards'" role="group" [attr.aria-label]="'SPACES.CONTINUE_AS' | translate">
  @if (variant === 'compact') {
    <span class="sw__label">{{ 'SPACES.CONTINUE_AS' | translate }}</span>
  }
  @for (s of spaces; track s.id) {
    <button type="button" class="sw__item" [attr.aria-pressed]="s.id === current" (click)="select.emit(s.id)">
      <i [class]="s.icon" aria-hidden="true"></i>
      <span class="sw__text">
        <span class="sw__name">{{ s.labelKey | translate }}</span>
        @if (variant === 'cards') { <small class="sw__hint">{{ s.hintKey | translate }}</small> }
      </span>
    </button>
  }
</div>
